module.exports = __webpack_public_path__ + "img/public_resources_wholemode_white.8a411ab8.svg";